<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <div class="h-40 flex a-center j-center">
      <span class="fs-14 bold">批量上传</span>
    </div>
    <div class="p-h-20" style="min-height: 400px;">
      <Row :gutter="15">
        <Col span="16">
          <class-vertical-choose-widget :objData="editData.objChange" :srcType="6"
                                        direction="horizontal"></class-vertical-choose-widget>
        </Col>
      </Row>
      <div class="m-t-20 flex flex-wrap o-y-auto noscroll"
           style="margin-left: -10px;margin-right: -10px;max-height:556px">
        <up-load-image @uploadSuccess="uploadCoverImageSuccess" @uploadprogress="uploadCoverImageProgress"
                       @uploadstart="uploadCoverImageStart" accept="image/*" class="m-7" multiple
                       picurl="common/desc/"
                       style="height:125px;width: 125px">
          <div class="w-full h-full" slot="tip">
            <div class="w-full  h-full flex a-center j-center" style="background: #F8F8F9;">
              <div class="flex-column a-center">
                <img alt="" class="w-full h-full" src="../../../../assets/common/img_addzhutu.png">
              </div>
            </div>
          </div>
        </up-load-image>
        <div :key="index" class="relative m-7 Imgbox border"
             style="height:125px;width: 125px" v-for="(item,index) in editData.picList">
          <img :src="getShowImg(item)" alt="" class="w-full h-full" style="border-radius: 4px;">
          <img @click="onItemDelClick(item,index)"
               alt="" class="picImgHover"
               src="../../../../assets/common/ic_yichu.png" style="position: absolute;right: -11px;top: -11px">
        </div>
      </div>
    </div>
    <div class="h-40 flex a-to j-center">
      <Button @click="onCancelClick" style="width: 100px">取消</Button>
      <Button @click="onOkClick" class="m-l-30" style="width: 100px" type="primary">确定</Button>
    </div>

    <Modal :closable="false" :mask-closable="false" class="prewmodal" class-name="vertical-center-modal" footer-hide
           v-model="showUploadProgress"
           width="720">
      <div class="p-h-20 p-b-20">
        <div class="h-40 flex a-center j-center">
          上传进度 <span>{{uploadProgressInfo.finishnum}}</span> / <span>{{uploadProgressInfo.totalnum}}</span>
        </div>
        <Progress :percent="uploadProgressInfo.percent" :stroke-width="20" text-inside/>
      </div>
    </Modal>

  </div>
</template>

<script>
import {mapActions} from 'vuex'
import ClassVerticalChooseWidget from '../../../../components/common/ClassVerticalChooseWidget'
import UpLoadImage from '../../../../components/common/UpLoadImage'

export default {
  name: 'MuliteUploadPicWidget',
  components: {UpLoadImage, ClassVerticalChooseWidget},
  props: {
    editData: {
      type: Object,
      default: () => {
        return {
          objChange: {                               //分类分组帅选
            classId: 0,
            groupId: 0,
            init: false
          },
          picList: []
        }
      }
    }
  },
  data () {
    return {
      showUploadProgress: false,                    //上传进度弹框
      uploadProgressInfo: {
        finishnum: 0,
        totalnum: 0,
        percent: 0
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    getShowImg (item) {
      return item.localUrl || item.url + '?x-oss-process=image/resize,w_200,limit_1/format,png'
    },
    onCancelClick () {
      this.$emit('cancel')
    },
    onOkClick () {
      if (this.editData.picList && this.editData.picList.length) {
        let params = this.editData.picList.map(child => {
          return {
            title: child.oldname || '',
            url: child.url,
            width: child.width,
            height: child.height,
            groupId: this.editData.objChange.groupId || 0,
            categoryId: this.editData.objChange.classId || 0,
            desc: ''
          }
        })
        this.addNewPic(params).then(res => {
          if (res.code === 0) {
            this.$emit('ok')
          }
          if (res.msg) {
            this.$Message.info(res.msg)
          }
        })
      } else {
        this.$emit('cancel')
      }
    },
    uploadCoverImageStart (progressdata) {
      this.uploadProgressInfo.finishnum = progressdata.finshnum || 0
      this.uploadProgressInfo.totalnum = progressdata.totalnum || 1
      this.uploadProgressInfo.percent = this.uploadProgressInfo.totalnum > 0 ? parseInt(this.uploadProgressInfo.finishnum * 100 / this.uploadProgressInfo.totalnum) : 0
      this.showUploadProgress = true
    },
    uploadCoverImageProgress (progressdata) {
      this.uploadProgressInfo.finishnum = progressdata.finshnum || 0
      this.uploadProgressInfo.totalnum = progressdata.totalnum || 1
      this.uploadProgressInfo.percent = this.uploadProgressInfo.totalnum > 0 ? parseInt(this.uploadProgressInfo.finishnum * 100 / this.uploadProgressInfo.totalnum) : 0
    },
    uploadCoverImageSuccess (data) {
      this.showUploadProgress = false
      this.uploadProgressInfo = {
        finishnum: 0,
        totalnum: 0,
        percent: 0
      }
      if (data && data.length) {
        this.editData.picList = this.editData.picList.concat(data)
      }
    },
    //清除该图片数据
    onItemDelClick (item, index) {
      this.editData.picList.splice(index, 1)
    },
    ...mapActions([
      'addNewPic',
    ]),
  }
}
</script>

<style lang="scss" scoped>

  .Imgbox:hover .picImgHover {
    display: block;
  }

  .picImgHover {
    display: none;
  }

</style>
